export const APP_TIME_ZONE = 'America/Argentina/Buenos_Aires';

function parseTimeParts(value: string): { hours: number; minutes: number } {
  const match = /^(\d{1,2}):(\d{2})/.exec(value.trim());
  if (!match) return { hours: 0, minutes: 0 };

  let hours = Number(match[1]);
  const minutes = Number(match[2]);
  const meridiem = value.toLowerCase().replace(/[.\s]/g, '');
  if (meridiem.includes('pm') && hours < 12) hours += 12;
  if (meridiem.includes('am') && hours === 12) hours = 0;
  return { hours, minutes };
}

export function parseSaleDateTime(dateValue: string, timeValue = '00:00'): Date {
  const dateMatch = /^(\d{4})-(\d{2})-(\d{2})$/.exec(dateValue);
  if (!dateMatch) return new Date(dateValue);

  const { hours, minutes } = parseTimeParts(timeValue);
  const offsetDate = `${dateMatch[1]}-${dateMatch[2]}-${dateMatch[3]}T${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:00-03:00`;
  return new Date(offsetDate);
}

export function formatSaleTime(timeValue: string): string {
  if (!timeValue) return '-';
  const { hours, minutes } = parseTimeParts(timeValue);
  return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
}

function getZonedParts(value: string | Date) {
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return null;
  const parts = new Intl.DateTimeFormat('en-CA', {
    timeZone: APP_TIME_ZONE,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hourCycle: 'h23',
  }).formatToParts(date);
  return Object.fromEntries(parts.map((part) => [part.type, part.value]));
}

export function toAppDateTime(value: string | Date): { date: string; time: string } {
  const parts = getZonedParts(value);
  if (!parts) return { date: '', time: '' };
  return {
    date: `${parts.year}-${parts.month}-${parts.day}`,
    time: `${parts.hour}:${parts.minute}`,
  };
}

export function formatAppDate(value: string | Date): string {
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return '-';
  return new Intl.DateTimeFormat('es-AR', {
    timeZone: APP_TIME_ZONE,
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  }).format(date);
}

export function formatAppTime(value: string | Date): string {
  const parts = getZonedParts(value);
  if (!parts) return '-';
  return formatSaleTime(`${parts.hour}:${parts.minute}`);
}
